import React from 'react'
import Barcode from 'react-barcode'

import { useProfile } from '@/hooks'
import { padZero } from '@/services/utils'

import { Box, Divider, Typography } from '@material-ui/core'

import ticketLogoVillagresVillacol from '@/assets/images/ticket-logo-villagres-villacol.png'
import ticketLogoVillacol from '@/assets/images/ticket-logo-villacol.png'
import ticketLogoVillagres from '@/assets/images/ticket-logo-villagres.jpeg'

import formatter from '@/services/formatter'

export function CollectPrintHeader(props) {
  const { data } = props

  const currentTicketLogo = React.useMemo(() => {
    if (!data) return ticketLogoVillagres

    const companyIds = [...new Set([...data.items.map((item) => item.id_cia)])] // [1, 2]

    if (companyIds.includes(1) && companyIds.includes(2)) {
      return ticketLogoVillagresVillacol
    }

    if (companyIds.includes(2)) {
      return ticketLogoVillacol
    }

    return ticketLogoVillagres
  }, [data])

  const profile = useProfile()
  const encryptedId = padZero(10, data.id)

  if (!data) {
    return null
  }

  return (
    <Box display="flex" flexDirection="column" gridGap="1.4rem">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Barcode height={60} value={encryptedId} displayValue />

        <Box>
          <Box
            component="img"
            src={currentTicketLogo}
            alt="Villagres"
            width="100%"
            maxWidth={200}
          />
        </Box>
      </Box>

      <Divider />

      <Box px={2} display="flex" justifyContent="space-between">
        <Box display="flex" flexDirection="column">
          <Typography
            component="span"
            color="primary"
            variant="h4"
            gutterBottom
          >
            {data.id}
          </Typography>

          <Typography component="span" variant="body1">
            {profile?.company.emp_razao_social}
          </Typography>

          <Typography component="span" variant="body1" gutterBottom>
            {formatter(profile.id).toCNPJ()}
          </Typography>
        </Box>

        <Box display="flex" flexDirection="column">
          <Typography component="span" variant="body1">
            Emissão: {data.date}
          </Typography>

          <Typography component="span" variant="body1" color="textSecondary">
            Impressão: {data.printDate}
          </Typography>

          {/* <Typography component="span" color="textSecondary" gutterBottom>
            {data.status.descr}
          </Typography> */}

          {data.lastUpdateDate && (
            <Typography component="span">
              Última atualização em: {data.lastUpdateDate}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}
